import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { localeShortDateTime } from "../../../../app/datetimeUtils";
import { useAppSelector } from "../../../../app/hooks";
import { isAdminRole } from "../../../../app/userSlice";
import { AvatarWithName } from "../../../../components/Avatar";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { PeerReviewReceived } from "./studentUsageReportApiSlice";

interface ReviewsGivenTableProps {
	className?: string;
	peerReviewsReceived: PeerReviewReceived[];
}

export function ReviewsReceivedTable(props: ReviewsGivenTableProps) {
	const { role } = useAppSelector((state) => state.user);

	const dateTimeTemplate = (rowData: PeerReviewReceived) => {
		return isAdminRole(role) ? (
			localeShortDateTime(rowData.reviewDate)
		) : (
			<Link className="link" to={`/reviews/${rowData.reviewId}`}>
				{localeShortDateTime(rowData.reviewDate)}
			</Link>
		);
	};

	const authorTemplate = (rowData: PeerReviewReceived) => {
		return (
			<AvatarWithName
				userId={rowData.reviewerId}
				name={rowData.reviewerName}
				initials={rowData.reviewerInitials}
				hasImage={rowData.reviewerHasImage}
			/>
		);
	};

	return (
		<DataTable
			value={props.peerReviewsReceived}
			dataKey="reviewId"
			loading={props.peerReviewsReceived == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className ?? ""}`}>
			<Column
				header="Date"
				body={dateTimeTemplate}
				sortable
				sortField="lastUsedDate"></Column>
			<Column header="Prompt" field="promptName" sortable></Column>
			<Column header="Author" body={authorTemplate} sortable sortField="writerName"></Column>
		</DataTable>
	);
}
